/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Add"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remove all"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enCA = Object.assign(TranslationProviderComponent, {
  translations
});

export { enCA as e };
//# sourceMappingURL=en-CA-BkRk1H--.js.map
